/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Theme } from '@lib/theming/Theme'
import { Box, useMediaQuery } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import { Width } from '@ts/css'
import { StoresTicketSalesPageLayoutFragment } from '@ts/operations'
import React from 'react'

import StoresTicketBenefitsComparator from '../benefits/StoresTicketBenefitsComparator'
import StoresSaleProductList, { ProductProps } from '../tickets/StoresSaleProductList'

export type StoresOffersTableProps = {
  benefitsList?: StoresTicketSalesPageLayoutFragment['benefitsList'] | null
  country: string
  currencySymbol: string
  displayPriceIncludingTax?: boolean
  minSpacerWidth?: Width
  products?: Array<ProductProps>
}

const StoresOffersTable = ({
  benefitsList,
  products,
  displayPriceIncludingTax = false,
}: StoresOffersTableProps) => {
  const { breakpoints } = useTheme<Theme>()
  const mdUp = useMediaQuery(breakpoints.up('md'))
  if (!products || products?.length === 0) {
    return null
  }
  const benefitsLabelsColumnMinWidth: Width = '22%'
  return (
    <Box m={0} maxWidth={1275} mx="auto">
      <StoresSaleProductList
        displayPriceIncludingTax={displayPriceIncludingTax || undefined}
        minSpacerWidth={benefitsLabelsColumnMinWidth}
        products={products}
      />

      {mdUp && products && (
        <StoresTicketBenefitsComparator
          benefitsList={benefitsList}
          labelsColumnWidth={benefitsLabelsColumnMinWidth}
          products={products}
        />
      )}
    </Box>
  )
}

export default StoresOffersTable
